import {
  getUTCAfternoon,
  getUtcDayTime,
  utcDateTime,
} from '@epicuro-next/utilities';
import {
  NgbDate,
  NgbDateStruct,
  NgbTimeStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

export function ngbDateToDate(ngbDate: NgbDateStruct) {
  return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
}

export function ngbDateToUTC(
  ngbDate: NgbDateStruct,
  isUseUTCDayTimeConversion: boolean = false,
  isEndDate: boolean = false,
): string {
  const isoDate = DateTime.utc(
    ngbDate.year,
    ngbDate.month,
    ngbDate.day,
  ).toISO();

  const computedUtc = isEndDate
    ? getUtcDayTime(isoDate, true)
    : getUtcDayTime(isoDate);
  const utcAfternoon = getUTCAfternoon(isoDate);

  return isUseUTCDayTimeConversion ? computedUtc : utcAfternoon;
}

export function ngbDateTimeToUTC(
  ngbDate: NgbDateStruct,
  ngbTime: NgbTimeStruct,
): string {
  return DateTime.utc(
    ngbDate.year,
    ngbDate.month,
    ngbDate.day,
    ngbTime.hour,
    ngbTime.minute,
    ngbTime.second,
  ).toISO({ suppressMilliseconds: true });
}

export function UTCtoNGBStruct(date: string): NgbDateStruct {
  const { year, month, day } = utcDateTime(date);
  return {
    year,
    month,
    day,
  };
}

export function UTCtoNGBTimeStruct(date: string): NgbTimeStruct {
  const { hour, minute, second } = utcDateTime(date);
  return { hour, minute, second };
}

export function UTCtoNGB(date: string): NgbDate {
  return NgbDate.from(UTCtoNGBStruct(date)) as NgbDate;
}
